var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spa-payment-details-form" },
    [
      _c("SpaTermsAndConditions", {
        key: "spaTermsAndConditions",
        on: {
          "terms-and-conditions-validation-changed": function ($event) {
            return _vm.$emit("terms-and-conditions-validation-changed", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }